/* eslint-disable */ 
import React, {useState, useEffect} from 'react' ;
import MyVotes from '../containers/MyVotes';
import {getUserVotedElections, handleError} from '../Utils/API';
import Loader from '../components/Loader';

export default function MyVotesView () {


    const [elections,setElections] = useState(null)
    const getElectionsData = () => {
        getUserVotedElections().then(results => {
            console.log('results',results.data)
            setElections(results.data || [])
        }).catch(handleError)
    }
    useEffect(
        getElectionsData,[]
    )

    if(!elections){
        return <Loader/>; 
    }

    console.log('elections')
    return (
        <div>
            <MyVotes elections={elections}/>
        </div>
    )
}